// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".select[data-v-2d498d2e]{width:100%}@media(min-width:900px){.select[data-v-2d498d2e]{margin:unset}}select[data-v-2d498d2e]{width:100%;flex:1}.time-picker>div[data-v-2d498d2e]{flex:1}h5[data-v-2d498d2e]{margin-top:-20px;font-weight:700;display:block;margin-bottom:5px}p[data-v-2d498d2e]{margin-bottom:24px}@media(min-width:900px){p[data-v-2d498d2e]{margin-bottom:24px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
